module.exports = __webpack_public_path__ + "media/images/edit_icon-ae9f5bf9b2eaaf00e5b4ef810f6a4174.png";